import { render, staticRenderFns } from "./ServiceCommands.vue?vue&type=template&id=3c6d397e&scoped=true&"
import script from "./ServiceCommands.vue?vue&type=script&lang=js&"
export * from "./ServiceCommands.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCommands.vue?vue&type=style&index=0&id=3c6d397e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6d397e",
  null
  
)

export default component.exports